import React, { useEffect, useState } from "react";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";

import Videos from "../Videos";
import Benefits from "../QuizDetails/Copmonents/Benefits";
import Details from "../QuizDetails/Copmonents/Details";
import featureImg1 from "../../../../../Assets/Images/feature-img1.svg";
import featureImg2 from "../../../../../Assets/Images/feature-img2.svg";
import featureImg3 from "../../../../../Assets/Images/feature-img3.svg";
import { URLRegex, getAgeRange } from "../../../../../helper"

import { getActivityList } from "../../../../../redux/actions/event";
import "./style.css";
import { useDispatch } from "react-redux";
import moment from "moment";

const TopTabs = ({ data, categoryId, eventDetails, ageGrp, classGrp, ageRange, classRange }) => {

  const dispatch = useDispatch();

  const [age, setAge] = useState(ageGrp);
  const [clas, setClas] = useState(classGrp);

  useEffect(() => {
    if (age) {
      const [min_age, max_age] = age?.split("-")
      dispatch(getActivityList({ category_id: categoryId, competition_id: eventDetails?.event_id, min_age, max_age }))
    }
    if (clas) {
      const [min_class, max_class] = clas?.split("-")
      dispatch(getActivityList({ category_id: categoryId, competition_id: eventDetails?.event_id, min_class, max_class }))
    }
    if (!age && !clas) {
      dispatch(getActivityList({ category_id: categoryId, competition_id: eventDetails?.event_id }))
    }
  }, [age, clas])

  return (
    <div className="top-tabs">
      <Tabs defaultActiveKey="quizdetails" id="uncontrolled-tab-example" className="mb-3">
        <Tab eventKey="quizdetails" title="Quiz details">
          <div className="quiz-details container mx-auto">
            <div className="features">
              <div className="head  mt-5">
                <p className="feature-hdng mb-0">
                  {age && <>For participants born on or between {moment(eventDetails?.start_date).subtract(getAgeRange(age)[1] + 1, 'years').add(1, 'days').format("Do MMM Y")} & {moment(eventDetails?.start_date).subtract(getAgeRange(age)[0], 'years').format("Do MMM Y")}</>}
                </p>
                {ageRange?.length > 0 && <select className="form-select btn-outline-bl" onChange={(e) => setAge(e.target.value)} value={age}>
                  {ageRange?.map((item, index) => <option value={`${item?.minimum}-${item?.maximum}`} key={index}>{item?.name}</option>)}
                </select>}
                {classRange?.length > 0 && <select className="form-select btn-outline-bl" onChange={(e) => setClas(e.target.value)} value={clas}>
                  {classRange?.map((item, index) => <option value={`${item?.minimum}-${item?.maximum}`} key={index}>{item?.name}</option>)}
                </select>}
              </div>
              <div className="row">
                <div className="col-lg-4 col-md-4">
                  <img className="feature-img" src={featureImg1} alt="" />
                  <p className="img-desc text-center">Short, fun quizzes</p>
                </div>
                <div className="col-lg-4 col-md-4">
                  <img className="feature-img" src={featureImg2} alt="" />
                  <p className="img-desc text-center">15 questions, 10 minutes</p>
                </div>
                <div className="col-lg-4 col-md-4">
                  <img className="feature-img" src={featureImg3} alt="" />
                  <p className="img-desc text-center">Share & compete with friends</p>
                </div>
              </div>
            </div>
            <h5 className="feature-hdng text-center mt-5">Benefits of Quizzing</h5>
            <Benefits />
            <Details data={data} />
          </div>
        </Tab>
        <Tab eventKey="watchVideo" title="Watch Video">
          {data?.[0]?.activityDetails?.youtube?.map(item => {
            const videoSrc = URLRegex.test(item.url) ? item.url : `https://www.youtube.com/embed/${item.url}`;
            return <Videos URL={videoSrc} />
          })}
        </Tab>
      </Tabs>
    </div>
  );
};

export default TopTabs;
